var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptimism(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0420;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1995692876000"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2500,1250C2500,560,1940,0,1250,0S0,560,0,1250s560,1250,1250,1250S2500,1940,2500,1250z",
    style: {
      fill: "#FF0420"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M886,1582c-75,0-136-18-183-53c-47-36-71-87-71-152c0-14,2-31,5-51c8-45,20-99,35-163c43-172,153-258,330-258    c48,0,92,8,130,25c38,16,68,40,90,72s33,69,33,113c0,13-2,30-5,50c-10,56-21,110-34,163c-22,86-60,150-114,193    c-54,42-126,63-216,63V1582z M900,1447c35,0,65-11,89-31c25-21,43-52,54-95c15-59,26-110,33-154c3-13,4-27,4-41c0-57-30-86-89-86    c-35,0-65,11-90,31c-25,21-42,52-53,95c-12,42-23,93-34,154c-3,13-4,26-4,40C809,1418,840,1447,900,1447z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1297,1573c-7,0-12-2-16-7c-3-5-4-11-3-17l130-610c1-7,5-13,11-17c6-5,12-7,18-7h250c70,0,125,15,167,43    c43,29,64,71,64,125c0,16-2,32-6,49c-16,72-47,125-95,160c-47,35-112,52-194,52h-127l-43,206c-2,7-5,13-11,17c-6,5-12,7-18,7h-128    L1297,1573z M1629,1214c27,0,49-7,69-22s33-35,40-62c2-11,3-20,3-28c0-18-6-32-16-42c-11-10-29-15-55-15h-113l-36,168h108V1214z",
    style: {
      fill: "#FFFFFF"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptimism);
export default __webpack_public_path__ + "static/media/optimism.c7506530e549ac46535cced48ab7c6d7.svg";
export { ForwardRef as ReactComponent };